import {
  createCustomization as publicCreateCustomization,
  getCustomization as publicGetCustomization,
  updateCustomization as publicUpdateCustomization,
  deleteCustomization as publicDeleteCustomization,
  queryCustomizations as publicQueryCustomizations,
  typedQueryCustomizations as publicTypedQueryCustomizations,
  bulkCreateCustomizations as publicBulkCreateCustomizations,
  addCustomizationChoices as publicAddCustomizationChoices,
  setCustomizationChoices as publicSetCustomizationChoices,
  removeCustomizationChoices as publicRemoveCustomizationChoices,
  updateCustomizationChoices as publicUpdateCustomizationChoices,
  reorderCustomizationChoices as publicReorderCustomizationChoices,
  bulkAddCustomizationChoices as publicBulkAddCustomizationChoices,
  bulkUpdateCustomizations as publicBulkUpdateCustomizations,
} from './stores-catalog-v3-customization-customizations-v-3.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  CustomizationQuery,
  CustomizationsQueryBuilder,
  QueryCustomizationsOptions,
  typedQueryCustomizations as universalTypedQueryCustomizations,
} from './stores-catalog-v3-customization-customizations-v-3.universal.js';
import { onCustomizationCreated as publicOnCustomizationCreated } from './stores-catalog-v3-customization-customizations-v-3.public.js';
import { onCustomizationDeleted as publicOnCustomizationDeleted } from './stores-catalog-v3-customization-customizations-v-3.public.js';
import { onCustomizationUpdated as publicOnCustomizationUpdated } from './stores-catalog-v3-customization-customizations-v-3.public.js';

function customQueryCustomizations(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryCustomizationsOptions) =>
      publicQueryCustomizations(httpClient)(options),
    typedQueryFunction: (
      query: CustomizationQuery,
      options?: QueryCustomizationsOptions
    ) => publicTypedQueryCustomizations(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: CustomizationQuery,
    options?: QueryCustomizationsOptions
  ): ReturnType<typeof universalTypedQueryCustomizations>;
  function overloadedQuery(
    options?: QueryCustomizationsOptions
  ): CustomizationsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: CustomizationQuery | QueryCustomizationsOptions,
    options?: QueryCustomizationsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createCustomization: MaybeContext<
  BuildRESTFunction<typeof publicCreateCustomization> &
    typeof publicCreateCustomization
> = /*#__PURE__*/ createRESTModule(publicCreateCustomization);
export const getCustomization: MaybeContext<
  BuildRESTFunction<typeof publicGetCustomization> &
    typeof publicGetCustomization
> = /*#__PURE__*/ createRESTModule(publicGetCustomization);
export const updateCustomization: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCustomization> &
    typeof publicUpdateCustomization
> = /*#__PURE__*/ createRESTModule(publicUpdateCustomization);
export const deleteCustomization: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCustomization> &
    typeof publicDeleteCustomization
> = /*#__PURE__*/ createRESTModule(publicDeleteCustomization);
export const bulkCreateCustomizations: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateCustomizations> &
    typeof publicBulkCreateCustomizations
> = /*#__PURE__*/ createRESTModule(publicBulkCreateCustomizations);
export const addCustomizationChoices: MaybeContext<
  BuildRESTFunction<typeof publicAddCustomizationChoices> &
    typeof publicAddCustomizationChoices
> = /*#__PURE__*/ createRESTModule(publicAddCustomizationChoices);
export const setCustomizationChoices: MaybeContext<
  BuildRESTFunction<typeof publicSetCustomizationChoices> &
    typeof publicSetCustomizationChoices
> = /*#__PURE__*/ createRESTModule(publicSetCustomizationChoices);
export const removeCustomizationChoices: MaybeContext<
  BuildRESTFunction<typeof publicRemoveCustomizationChoices> &
    typeof publicRemoveCustomizationChoices
> = /*#__PURE__*/ createRESTModule(publicRemoveCustomizationChoices);
/** @internal */
export const updateCustomizationChoices: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCustomizationChoices> &
    typeof publicUpdateCustomizationChoices
> = /*#__PURE__*/ createRESTModule(publicUpdateCustomizationChoices);
/** @internal */
export const reorderCustomizationChoices: MaybeContext<
  BuildRESTFunction<typeof publicReorderCustomizationChoices> &
    typeof publicReorderCustomizationChoices
> = /*#__PURE__*/ createRESTModule(publicReorderCustomizationChoices);
export const bulkAddCustomizationChoices: MaybeContext<
  BuildRESTFunction<typeof publicBulkAddCustomizationChoices> &
    typeof publicBulkAddCustomizationChoices
> = /*#__PURE__*/ createRESTModule(publicBulkAddCustomizationChoices);
export const bulkUpdateCustomizations: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateCustomizations> &
    typeof publicBulkUpdateCustomizations
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateCustomizations);
export const queryCustomizations: MaybeContext<
  BuildRESTFunction<typeof customQueryCustomizations> &
    typeof customQueryCustomizations
> = /*#__PURE__*/ createRESTModule(customQueryCustomizations);
/**
 * Triggered when a customization is created.
 */
export const onCustomizationCreated: BuildEventDefinition<
  typeof publicOnCustomizationCreated
> &
  typeof publicOnCustomizationCreated = createEventModule(
  publicOnCustomizationCreated
);
/**
 * Triggered when a customization is deleted.
 */
export const onCustomizationDeleted: BuildEventDefinition<
  typeof publicOnCustomizationDeleted
> &
  typeof publicOnCustomizationDeleted = createEventModule(
  publicOnCustomizationDeleted
);
/**
 * Triggered when a customization is updated.
 */
export const onCustomizationUpdated: BuildEventDefinition<
  typeof publicOnCustomizationUpdated
> &
  typeof publicOnCustomizationUpdated = createEventModule(
  publicOnCustomizationUpdated
);

export {
  CustomizationType,
  CustomizationRenderType,
  ChoiceType,
  ChoiceSortStrategy,
  RequestedFields,
  SortOrder,
  WebhookIdentityType,
} from './stores-catalog-v3-customization-customizations-v-3.universal.js';
export {
  Customization,
  CustomizationCustomizationSettingsOneOf,
  FreeTextSettings,
  ChoicesSettings,
  Choice,
  ChoiceValueOneOf,
  MultipleColors,
  FocalPoint,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CreateCustomizationRequest,
  CreateCustomizationResponse,
  GetCustomizationRequest,
  GetCustomizationResponse,
  UpdateCustomizationRequest,
  UpdateCustomizationResponse,
  DeleteCustomizationRequest,
  DeleteCustomizationResponse,
  QueryCustomizationsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryCustomizationsResponse,
  CursorPagingMetadata,
  Cursors,
  BulkCreateCustomizationsRequest,
  BulkCreateCustomizationsResponse,
  BulkCustomizationResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  CustomizationIdsWrapper,
  BulkCreateCustomizationsForMigrationRequest,
  BulkCreateCustomizationsForMigrationResponse,
  AddCustomizationChoicesRequest,
  AddCustomizationChoicesResponse,
  SetCustomizationChoicesRequest,
  SetCustomizationChoicesResponse,
  RemoveCustomizationChoicesRequest,
  RemoveCustomizationChoicesResponse,
  UpdateCustomizationChoicesRequest,
  MaskedChoice,
  UpdateCustomizationChoicesResponse,
  ReorderCustomizationChoicesRequest,
  ReorderCustomizationChoicesResponse,
  ChoiceIdsMismatchData,
  BulkAddCustomizationChoicesRequest,
  CustomizationChoices,
  BulkAddCustomizationChoicesResponse,
  BulkUpdateCustomizationsRequest,
  MaskedCustomization,
  BulkUpdateCustomizationsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  RecloneSiteRequest,
  RecloneSiteResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  CustomizationCreatedEnvelope,
  CustomizationDeletedEnvelope,
  CustomizationUpdatedEnvelope,
  GetCustomizationOptions,
  UpdateCustomization,
  UpdateCustomizationOptions,
  QueryCustomizationsOptions,
  CustomizationsQueryResult,
  CustomizationsQueryBuilder,
  CustomizationQuerySpec,
  BulkCreateCustomizationsOptions,
  AddCustomizationChoicesOptions,
  SetCustomizationChoicesOptions,
  RemoveCustomizationChoicesOptions,
  UpdateCustomizationChoicesOptions,
  ReorderCustomizationChoicesOptions,
  BulkAddCustomizationChoicesOptions,
  BulkUpdateCustomizationsOptions,
} from './stores-catalog-v3-customization-customizations-v-3.universal.js';
export { utils } from './stores-catalog-v3-customization-customizations-v-3.universal.js';
export {
  CustomizationTypeWithLiterals,
  CustomizationRenderTypeWithLiterals,
  ChoiceTypeWithLiterals,
  ChoiceSortStrategyWithLiterals,
  RequestedFieldsWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateCustomizationApplicationErrors,
  CreateCustomizationValidationErrors,
  DeleteCustomizationValidationErrors,
  BulkCreateCustomizationsApplicationErrors,
  BulkCreateCustomizationsValidationErrors,
  AddCustomizationChoicesApplicationErrors,
  AddCustomizationChoicesValidationErrors,
  SetCustomizationChoicesApplicationErrors,
  SetCustomizationChoicesValidationErrors,
  RemoveCustomizationChoicesApplicationErrors,
  RemoveCustomizationChoicesValidationErrors,
  UpdateCustomizationChoicesApplicationErrors,
  UpdateCustomizationChoicesValidationErrors,
  ReorderCustomizationChoicesApplicationErrors,
  BulkAddCustomizationChoicesApplicationErrors,
  BulkAddCustomizationChoicesValidationErrors,
  CommonQueryWithEntityContext,
  CustomizationQuery,
} from './stores-catalog-v3-customization-customizations-v-3.universal.js';
